import { IncidentsApiAdapter } from '../adapters/IncidentsApiAdapter';
import { IncidentFilters } from '../models/Filters';
import { IncidentsPage } from '../adapters/IncidentsApiAdapter';

export interface Page {
  data: any[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
  meta?: {
    currentPage: number;
    lastPage: number;
    total: number;
    perPage: number;
  };
}

export class Service {
  constructor(private apiAdapter: IncidentsApiAdapter) {}

  async getPaginated(filters: IncidentFilters & { page?: number }): Promise<Page> {
    const page = filters.page ?? 1;
    const response = await this.apiAdapter.getIncidents({
      ...filters,
      page,
    });

    return {
      data: response.data,
      nextPage:
        response.meta.currentPage < response.meta.lastPage
          ? response.meta.currentPage + 1
          : undefined,
      hasMore: response.meta.currentPage < response.meta.lastPage,
      total: response.meta.total,
      meta: response.meta,
    };
  }
}
